import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
	selector: '[snDatePickerValidator]'
})
export class SnDatePickerValidatorDirective {
	private element;

	constructor(el: ElementRef) {
		this.element = el;
	}

	@HostListener('inputFieldChanged', ['$event'])
	onDateChanged(event) {
		const datepicker = this.element.nativeElement.querySelector(
			'input[ngtype="text"]'
		);
		if (datepicker) {
			if (!event.valid) {
				datepicker.setCustomValidity(
					'Please provide a date in the right format.'
				);
			} else {
				datepicker.setCustomValidity('');
			}
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/directives/sn-date-picker-validator/sn-date-picker-validator.directive.ts